import Checkout from "@components/Accesses/AccessDetails/screens/Checkout";

export default Checkout;
